import { Store } from "lucide-react";
import { trpc } from "@/lib/trpc";
import SalonStorePage from "./SalonStorePage";

interface CustomStoreDomainPageProps {
  domain: string;
}

/**
 * A hospedagem encaminha o domínio para este projeto. Esta página resolve a
 * unidade somente por um domínio previamente verificado, sem depender do
 * Host header no servidor e sem expor configurações de outra unidade.
 */
export default function CustomStoreDomainPage({
  domain,
}: CustomStoreDomainPageProps) {
  const { data: salon, isLoading } = trpc.salon.getByStoreDomain.useQuery(
    { domain },
    { enabled: !!domain }
  );

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-6 text-center">
        <div className="space-y-3">
          <Store className="mx-auto h-8 w-8 animate-pulse text-primary" />
          <p className="text-sm text-muted-foreground">Carregando loja...</p>
        </div>
      </div>
    );
  }

  if (!salon) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-6 text-center">
        <div className="max-w-md space-y-3 rounded-xl border border-border bg-card p-6 shadow-sm">
          <Store className="mx-auto h-8 w-8 text-muted-foreground" />
          <h1 className="text-lg font-semibold">Loja indisponível</h1>
          <p className="text-sm text-muted-foreground">
            Este domínio ainda não está vinculado a uma loja pública verificada.
          </p>
        </div>
      </div>
    );
  }

  return <SalonStorePage salonSlug={salon.slug} isCustomStoreDomain />;
}
